<!-- 顶部导航组件 -->
<!-- 使用说明：<top-bar></top-bar> -->
<template>
    <div id="topbar-wrap" :class="{ topCollapsed: isCollapse }">
        <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <h3 class="logo">
                <img src="@/assets/images/logo.png"/>
                <span class="rythm twist1">镜面系统-可视化综合分析工作台</span>
              </h3>
              <!-- <h3 class="logo">
                <span class="rythm twist1">镜面系统：可视化综合分析平台</span>
              </h3> -->
                <!-- <i :class="[isCollapse? 'nav-rotate': '','fa fa-bars']" @click="toggleSiderBar"></i> -->
            </el-col>
            <el-col>
                <el-row type="flex" class="row-right" justify="end">
                    <el-col style="padding-right:35px;text-align:right;">
                        <!-- <a class="animated fadeIn">{{$t('m.topbar.sayHi')}}，{{userName}}</a> -->
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link animated fadeIn">
                           {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <!-- <span style="color:red;">id:{{id}}</span>
                        <span style="color:red;">permission:{{permission}}</span> -->
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item><i @click.prevent="FedLogOut">退出登录</i></el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                    <!-- <el-col :span="2">
                        <i class="fa fa-language" title="切换语言" @click="toggleLanguage"></i>
                    </el-col>
                    <el-col :span="2">
                        <i class="fa fa-arrows-alt" title="切换全屏" @click="toggleFullscreen"></i>
                    </el-col>-->
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
let common = {
    state: {
        isCollapse: false,
        chartTheme: ["#2ec7c9", "#b6a2de", "#5ab1ef", "#ffb980", "#d87a80", "#8d98b3", "#e5cf0d", "#97b552", "#95706d", "#dc69aa", "#07a2a4", "#9a7fd1", "#588dd5", "#f5994e", "#c05050", "#59678c", "#c9ab00", "#7eb00a", "#6f5553", "#c14089"],
    },
    mutations: {
        toggleSiderBar(state) {
            state.isCollapse = !state.isCollapse
        }
    }
}
import screenfull from 'screenfull'
import store from '../store'
import {mapGetters, mapActions } from 'vuex'
export default {
  name: 'topbar',
  data() {
    return {
      userName: localStorage.loginname || '',
      id: '',
      permission:''
    }
  },
  created(){
    this.id = this.$store.getters.getId;
    // this.id = localStorage.id;
    
    this.permission = this.$store.getters.getPermission;
    // console.log(this.permission);
  },
  computed: {
    isCollapse() {
      return common.isCollapse
    }
  },
  mounted(){

  },
  methods: {
    toggleSiderBar() {
      this.$store.commit('toggleSiderBar')
    },
    toggleLanguage() {
      let locale = this.$i18n.locale
      locale === 'zh' ? (this.$i18n.locale = 'en') : (this.$i18n.locale = 'zh')
      let info = locale === 'en' ? '切换成功' : 'change language successfully'
      this.$message.success(info)
    },
    toggleFullscreen() {
      if (!screenfull.enabled) {
        this.$message({
          message: '您的浏览器不支持全屏',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
    },
    // 退出登录点击事件
    ...mapActions([
      'FedLogOut',
    ]),
  },
  watch: {
    $route(to, from) {
      this.pathName = this.$route.path.substring(1)
      this.nowPath = this.$route.path
    }
  }
}
</script>
<style scoped lang="scss">
.el-dropdown-link{
  font-size:16px;
  color:#FFF;
  cursor: pointer;
}
#topbar-wrap {
  // overflow: hidden;
  background: #4D74FF;
  color: #fff;
  // padding: 0 15px;
  box-sizing: border-box;
  // height:62px;
  // position:relative;
  // width:100%;
  min-width: 1200px;
  .logo {
    color: #fff;
    width:335px;
    text-align: center;
    background: #4D74FF;
    padding:0;
    margin: 0;
    height:60px;
    line-height:60px;
    display: flex;
    img{
        margin: 12px 6px 0 20px;
        display: inline-block;
        width: 37px;
        height: 37px;
    }
  }
  .freeBtn {
    margin-top: 12px;
    text-align: right;
  }
  .name {
    font-weight: 600;
  }
  .el-icon-setting {
    transition: 1s;
    &:hover {
      transform: rotate(180deg);
      cursor: pointer;
    }
  }
  .fa {
    font-size: 24px;
    transition: all 0.3s;
    &:hover {
      cursor: pointer;
    }
  }
  a {
    line-height: 60px;
  }
  a.logout {
    color: #fff;
    text-decoration: none;
    &:hover {
      color: #20a0ff;
    }
  }
  i {
    font-size: 20px;
    line-height: 60px;
  }
  .logout {
    color: #fff;
    &:hover {
      color: #20a0ff;
    }
  }
}
.fa.nav-rotate {
  transform: rotate(90deg);
}
.row-right > div {
  text-align: center;
}
</style>
